import groq from 'groq';

import { SLUG } from '../common';

export const PODCAST_BANNER = groq`
  _type,
  _key,
  ${SLUG},
  "thumbnail": episode.thumbnail,
  "episodeTitle": episode.episodeTitle,
  "podcastTitle": episode.podcastTitle,
  "duration": round(episode.duration / 60),
`;
